<template>
  <div class="SpHeader-modal-window">
    <button :class="[ isMenuActive ? 'menu-trigger active' : 'menu-trigger' ]" @click="triggerModal">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- コンポーネント MyModal -->
    <SpModal @close="triggerModal" v-if="spmodal">
    </SpModal>
  </div>
</template>

<script>
import SpModal from './SpModal.vue'
export default {
  components: { SpModal },
  data () {
    return {
      spmodal: false,
      isMenuActive: false
    }
  },
  methods: {
    triggerModal () {
      if (this.spmodal) {
        this.spmodal = false
        this.isMenuActive = false
        document.getElementById('pc-header').style.height = '8vh'
      } else {
        this.spmodal = true
        this.isMenuActive = true
        document.getElementById('pc-header').style.height = '100vh'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu-trigger,
.menu-trigger span {
  transition: all .4s;
  box-sizing: border-box;
}
.menu-trigger {
  position: absolute;
  width:  29px;
  height: 22px;
  padding: 4px 0;
  margin: 10px auto;
  top: 3px;
  right: 15px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 41;
  &:hover {
    opacity: .5;
  }
}
.menu-trigger span {
  display: inline-block;
  position: absolute;
  left: 0;
  height: 3px;
  background-color: #000;
}
.menu-trigger span:nth-of-type(1) {
  top: 0;
  width: 100%;
}
.menu-trigger span:nth-of-type(2) {
  top: 9px;
  width: 100%;
}
.menu-trigger span:nth-of-type(3) {
  bottom: 0;
  width: 100%;
}
.menu-trigger.active span:nth-of-type(1) {
  -webkit-transform: translateY(10px) rotate(-45deg);
  transform: translateY(10px) rotate(-45deg);
  width: 100%;
}
.menu-trigger.active span:nth-of-type(2) {
  opacity: 0;
}
.menu-trigger.active span:nth-of-type(3) {
  -webkit-transform: translateY(-8px) rotate(45deg);
  transform: translateY(-8px) rotate(45deg);
  width: 100%;
}
</style>
